import React, { useEffect } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const XYChart = () => {
  useEffect(() => {
    const root = am5.Root.new('xyChartDiv');
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, { layout: root.verticalLayout })
    );

    const xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, { renderer: am5xy.AxisRendererX.new(root, {}) })
    );

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, { renderer: am5xy.AxisRendererY.new(root, {}) })
    );

    const series = chart.series.push(
      am5xy.LineSeries.new(root, {
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: 'x',
        valueYField: 'y',
        stroke: am5.color(0xff0000),
        fill: am5.color(0xff0000),
        tooltip: am5.Tooltip.new(root, { labelText: '{valueX}, {valueY}' })
      })
    );

    series.data.setAll([
      { x: 10, y: 15 },
      { x: 20, y: 25 },
      { x: 30, y: 35 }
    ]);

    return () => root.dispose();
  }, []);

  return <div id="xyChartDiv" style={{ width: '100%', height: '400px' }}></div>;
};

export default XYChart;
